var PLANS = ['monthly', 'quarterly', 'annual', 'lifetime', 'trial'];

export default function validateKey(key) {
    if (!key) {
        return;
    }

    var data;

    key = key.slice(3, key.length);

    try { key = atob(key);        } catch (e) { }
    try { key = atob(key + '=');  } catch (e) { }
    try { key = atob(key + '=='); } catch (e) { }
    try { data = JSON.parse(key); } catch (e) { }

    if (typeof data === 'object') {
        data.isEmail = data.email && data.email.indexOf('@') !== -1;
        data.validStart = data.startAt && parseInt(data.startAt) > 10000;
        data.validPlan = data.plan && PLANS.indexOf(data.plan) !== -1;
        data.expired = data.expireAt && parseInt(data.expireAt) < Date.now();
        data.active = data.isEmail && data.validStart && data.validPlan && !data.expired;
    }

    return data;
}
